import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-section-gift-header',
  templateUrl: './section-gift-header.component.html',
  styleUrls: ['./section-gift-header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SectionGiftHeaderComponent {
  // constructor() {}
}
